import { render, staticRenderFns } from "./BasicDataSetting.vue?vue&type=template&id=94758d12&scoped=true&"
import script from "./BasicDataSetting.vue?vue&type=script&lang=js&"
export * from "./BasicDataSetting.vue?vue&type=script&lang=js&"
import style0 from "./BasicDataSetting.vue?vue&type=style&index=0&id=94758d12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94758d12",
  null
  
)

export default component.exports